import React from 'react'
import AgentAvatar from './AgentAvatar'
import AgentName from './AgentName'
import ListIcon from '@material-ui/icons/List'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles(theme => ({
  labelDiv: {
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    height: 35,
    width: 35,
    color: '#FFFFFF'
  },
  buttonRoot: {
    padding: 0
  },
  mobileChatHeader: {
    display: 'grid',
    gridTemplateColumns: '8fr 1fr 1fr',
    gridGap: 10,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '16px',
    fontWeight: 600,
    padding: '10px 10px 10px 15px',
    alignItems: 'center'
  }
}))

function MobileChatHeader (props) {
  const classes = useStyles()

  const size = 35

  return (
    <div className={classes.mobileChatHeader}>
      <div className='mobile-chat-label'>
        <AgentAvatar avatarUrl={props.avatarUrl} size={size} bot={props.bot} />
        <div className={classes.labelDiv}>
          <AgentName conversationLabel={props.conversationLabel} phone />
        </div>
      </div>
      <IconButton onClick={props.showConversationHistory} className={classes.button} classes={{ root: classes.buttonRoot }}>
        <ListIcon />
      </IconButton>
      <IconButton onClick={props.closeChat} className={classes.button} classes={{ root: classes.buttonRoot }}>
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default MobileChatHeader
